module.exports = __webpack_public_path__ + "13efd7cf4cdc935e3fe1f3305b06ac8d.jpg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/authors/brian.jpg
// module id = 483
// module chunks = 0